import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';


@Component({
  selector: 'modal-iof',
  templateUrl: './modal-iof.component.html',
  styleUrls: ['./modal-iof.component.scss'],
})
export class ModalIofComponent {

   iofTable: { dia: number; aliquota: number }[] = [
    { dia: 1, aliquota: 96 }, { dia: 2, aliquota: 93 }, { dia: 3, aliquota: 90 }, { dia: 4, aliquota: 86 }, { dia: 5, aliquota: 83 },
    { dia: 6, aliquota: 80 }, { dia: 7, aliquota: 76 }, { dia: 8, aliquota: 73 }, { dia: 9, aliquota: 70 }, { dia: 10, aliquota: 66 },
    { dia: 11, aliquota: 63 }, { dia: 12, aliquota: 60 }, { dia: 13, aliquota: 56 }, { dia: 14, aliquota: 53 }, { dia: 15, aliquota: 50 },
    { dia: 16, aliquota: 46 }, { dia: 17, aliquota: 43 }, { dia: 18, aliquota: 40 }, { dia: 19, aliquota: 36 }, { dia: 20, aliquota: 33 },
    { dia: 21, aliquota: 30 }, { dia: 22, aliquota: 26 }, { dia: 23, aliquota: 23 }, { dia: 24, aliquota: 20 }, { dia: 25, aliquota: 16 },
    { dia: 26, aliquota: 13 }, { dia: 27, aliquota: 10 }, { dia: 28, aliquota: 6 }, { dia: 29, aliquota: 3 }, { dia: 30, aliquota: 0 }
  ];
 
  constructor(private modalController:ModalController) {
  }


   get iofRows(): { dia: number; aliquota: number }[][] {
    const rows: { dia: number; aliquota: number }[][] = [];
    for (let i = 0; i < 10; i++) {
      rows.push([
        this.iofTable[i],
        this.iofTable[i + 10],
        this.iofTable[i + 20]
      ]);
    }
    return rows;
  }

   public goBack() {
    this.modalController.dismiss();
  }


  
}
